import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TeamsRoutingModule } from './teams-routing.module';
import { TeamsComponent } from './teams.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CreateTeamComponent } from './create-team/create-team.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [TeamsComponent, CreateTeamComponent],
  imports: [
    CommonModule,
    TeamsRoutingModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
})
export class TeamsModule {}
